import React, { useEffect, useState } from 'react';
import { ref, onValue, get } from 'firebase/database';
import { db } from '@react-native-firebase/database';
import StyleSheetRW from 'core/StyleSheetRW';
import Loader from 'src/components/Loader';
import Menu from './Menu';
import { TOTAL_HOLIDAY, MOBILE_VIEW_WIDTH } from 'res/constants';
import { Dimensions } from 'react-native';
import holidayIcon from "res/img/holidayIcon.png"
import worker from "res/img/worker.png"
import { Doughnut } from 'react-chartjs-2';
import 'chart.js/auto';
import { getLocalStorageItem } from 'core/helpers';
import navhelper from 'core/navhelper';
import { formatDaysAndHours } from 'src/utils/TimeOffRequestUtils';

const TeamAvailability: React.FC = () => {
    const [leaves, setLeaves] = useState<any>([]);
    const [showLoader, setShowLoader] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [searchQuery, setSearchQuery] = useState('');
    const screenWidth = Dimensions.get('window').width;
    const [holidaySummary, setHolidaySummary] = useState({
        daysTaken: 0,
        daysBooked: 0,
        daysRequested: 0,
        daysLeft: 0,
    });

    const [loggedinUserLeaves, setLoggedinUserLeaves] = useState<any>({});
    const [userProfileData, setUserProfileData] = useState<any>({
        totalHolidays: 0,
        employmentType: '',
    });
    const [showLoader2, setShowLoader2] = useState(false);




    const onNextWeek = () => {
        const nextWeekStartDate = new Date(startDate);
        nextWeekStartDate.setDate(nextWeekStartDate.getDate() + 7);
        setStartDate(nextWeekStartDate);
    };


    const onPrevWeek = () => {
        const prevWeekStartDate = new Date(startDate);
        prevWeekStartDate.setDate(prevWeekStartDate.getDate() - 7);
        setStartDate(prevWeekStartDate);
    };


    const fetchloggedinUserleaves = async () => {
        setShowLoader(true);
        try {
            const loggedinUser = getLocalStorageItem("loggedinUser");
            if (loggedinUser) {
                const dbRef = ref(db, `timeOffRequest/${loggedinUser.uid}`);
                await get(dbRef).then((snapshot) => {
                    if (snapshot.exists()) {
                        const data = snapshot.val();
                        setShowLoader(false);
                        setLoggedinUserLeaves(data);
                    } else {
                        setShowLoader(false);
                        setLoggedinUserLeaves({});
                    }
                }).catch((error) => {
                    setShowLoader(false);
                    setLoggedinUserLeaves({});
                    console.error("Failed to retrieve data:", error);
                });
            }
        } catch (error: any) {
            setShowLoader(false);
            console.error("Error reading data:", error.message);
        }
    };

    const fetchUserProfileData = async () => {
        setShowLoader2(true);
        const loggedinUser = getLocalStorageItem("loggedinUser");
        if (loggedinUser) {
            const dbRef = ref(db, `profile/${loggedinUser.uid}`);
            const snapshot = await get(dbRef);
            if (snapshot.exists()) {
                const totalHolidays = (snapshot.val().remainingCasualLeaves || 0) + (snapshot.val().remainingSickLeaves || 0)
                setUserProfileData({
                    ...userProfileData,
                    totalHolidays: (totalHolidays !== 0 ? totalHolidays : TOTAL_HOLIDAY),
                    employmentType: snapshot.val().employmentType,
                });
                setHolidaySummary({
                    ...holidaySummary,
                    daysLeft: (totalHolidays !== 0 ? totalHolidays : TOTAL_HOLIDAY) - holidaySummary.daysTaken - holidaySummary.daysBooked,
                })
                setShowLoader2(false);
            } else {
                setShowLoader2(false);
            }
        }
    };


    const calculateHolidaySummary = (leavesData: any) => {
        let daysTaken = 0;
        let daysBooked = 0;
        let daysRequested = 0;
        const currentDate = new Date();
        let employmentTypeHour = 0;


        for (const date in leavesData) {
            for (const leaveId in leavesData[date]) {
                const leave = leavesData[date][leaveId];
                const leaveStartDate = new Date(leave.startDate);
                const leaveEndDate = new Date(leave.endDate);

                let leaveDays = 0;
                employmentTypeHour = leave.employmentType === "Full Time" ? 8 : 4;


                if (leave.availability === "Full Day") {
                    leaveDays = (leaveEndDate - leaveStartDate) / (1000 * 60 * 60 * 24) + 1;
                } else if (leave.availability === "1st Half" || leave.availability === "2nd Half") {
                    const daysDiff = (leaveEndDate - leaveStartDate) / (1000 * 60 * 60 * 24) + 1;
                    leaveDays = 0.5 * daysDiff;
                } else if (leave.availability === "Specify hours" && leave.totalhours) {
                    const hours = parseInt(leave.totalhours);
                    leaveDays = (hours / employmentTypeHour);
                }

                if (leave.status === "Approved" && leaveStartDate <= currentDate) {
                    daysTaken += leaveDays;
                } else if (leave.status === "Approved" && leaveStartDate > currentDate) {
                    daysBooked += leaveDays;
                } else if (leave.status === "Applied") {
                    daysRequested += leaveDays;
                }
            }
        }

        const daysLeft = (userProfileData.totalHolidays !== 0 ? userProfileData.totalHolidays : TOTAL_HOLIDAY) - daysTaken - daysBooked;

        setHolidaySummary({
            daysTaken,
            daysBooked,
            daysRequested,
            daysLeft,
        });
    };



    useEffect(() => {
        fetchUserProfileData()
        fetchloggedinUserleaves();
    }, []);

    useEffect(() => {
        if (Object.keys(loggedinUserLeaves).length > 0 && userProfileData.totalHolidays !== 0) {
            calculateHolidaySummary(loggedinUserLeaves);
        }
    }, [loggedinUserLeaves, userProfileData]);

    useEffect(() => {
        setShowLoader(true);
        const dbRef = ref(db, 'timeOffRequest');
        const fetchRequestUpdatedData = onValue(dbRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const allTimeOffLists: any = Object.keys(data).map(userUID => {
                    const userData = data[userUID];
                    const userLeaveData: any = Object.values(userData).flatMap((val: any) => Object.values(val));
                    const userName = userLeaveData.length > 0 ? userLeaveData[0].name : '';
                    return { userUID, userLeaveData, userName };
                });
                setLeaves(allTimeOffLists);
                setShowLoader(false);
            } else {
                setShowLoader(false);
                console.log("No data available");
            }
        }, (error) => {
            setShowLoader(false);
            console.error("Failed to retrieve data:", error);
        });

        return () => {
            fetchRequestUpdatedData();
        };
    }, []);


    const filteredLeaves = leaves.filter((leave: any) => leave.userName.toLowerCase().includes(searchQuery.toLowerCase()));

    const doughnutData = {
        labels: ['Days Taken', 'Days Booked', 'Days Requested', 'Days Left'],
        datasets: [
            {
                data: [
                    holidaySummary.daysTaken,
                    holidaySummary.daysBooked,
                    holidaySummary.daysRequested,
                    holidaySummary.daysLeft
                ],
                backgroundColor: ['#c9014a', '#e6a975', '#0172c5', '#00804b'],
            }
        ]
    };

    const doughnutOptions = {
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
                callbacks: {
                    label: function (tooltipItem: any) {
                        const label = tooltipItem.label || '';
                        const value = tooltipItem.raw;
                        if (label) {
                            return `${label}: ${value} days`;
                        }
                        return `${value} days`;
                    }
                }
            }
        },
    };

    return (
        <div style={styles.mainContainer}>
            <Menu />
            <div style={{ overflowX: "hidden", width: screenWidth < MOBILE_VIEW_WIDTH ? "90%" : "100%", padding: '0px 0px 0px 20px' }}>
                <div style={{ width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "97%" }}>
                    <div>
                        <h1 style={styles.heading}>Team Availability</h1>
                    </div>
                    <div style={{ width: "100%", marginTop: 20 }}>
                        <h1 style={styles.tableHeading}>Your Holiday Summary</h1>
                        <div style={styles.holidaySummary}>
                            {!showLoader2 && !showLoader && (
                                <div style={{ width: "100%", height: screenWidth <= 425 ? "" : 200, display: screenWidth <= 425 ? "" : "flex", justifyContent: "space-between" }}>
                                    <Doughnut data={doughnutData} options={doughnutOptions} style={{ marginBottom: 10 }} />
                                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-around", gap: screenWidth <= 425 ? "20px" : "", textAlign: screenWidth <= 425 ? "center" : undefined }}>
                                        <span style={{ ...styles.summaryValue, color: "#c9014a" }}>{formatDaysAndHours(holidaySummary.daysTaken, userProfileData.employmentType)} taken</span>
                                        <span style={{ ...styles.summaryValue, color: "#e6a975" }}>{holidaySummary.daysBooked} days booked</span>
                                        <span style={{ ...styles.summaryValue, color: "#0172c5" }}>{holidaySummary.daysRequested} days requested</span>
                                        <span style={{ ...styles.summaryValue, color: "#00804b" }}>{formatDaysAndHours(holidaySummary.daysLeft, userProfileData.employmentType)} left</span>
                                    </div>
                                </div>
                            )}
                            <div style={{ marginTop: 10 }}>
                                <span>Your entitlement this holiday year is {`${userProfileData.totalHolidays !== 0 ? userProfileData.totalHolidays : TOTAL_HOLIDAY}`} days (inclusive of bank holidays)</span>
                            </div>
                            <button style={styles.holidayButton} onClick={() => navhelper.push("UserTimeOffRequest?showAddTimeOffRequestDialog")}>Request a holiday</button>
                        </div>
                    </div>
                    <div style={styles.tableContainer}>
                        <div style={styles.tableHeader}>
                            <h1 style={styles.tableHeading}>Your Team</h1>
                            {/* Search Bar */}
                            <input
                                type="text"
                                placeholder="Search by name"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={styles.input}
                            />
                        </div>
                        <div style={styles.tableWrapper}>
                            <table style={styles.tableStyle}>
                                <thead>
                                    <tr style={styles.tableRow}>
                                        <th style={{ ...styles.tableHead, textAlign: "left", }}>Team members</th>
                                        {[...Array.from(Array(7).keys())].map((dayIndex) => {
                                            const currentDate = new Date(startDate);
                                            currentDate.setDate(currentDate.getDate() - currentDate.getDay() + dayIndex + 1);
                                            const formattedDate = currentDate.toLocaleDateString('en-US', { month: 'short', day: '2-digit' });
                                            const formattedDay = currentDate.toLocaleDateString('en-US', { weekday: 'short' });
                                            const displayStyle = screenWidth <= MOBILE_VIEW_WIDTH && formattedDay.includes('S') ? 'none' : 'table-cell';
                                            return (
                                                <th key={dayIndex} style={{...styles.tableHead, display: displayStyle}}>
                                                    <div>{formattedDate}</div>
                                                    <div>{formattedDay}</div>
                                                </th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredLeaves.map((leave: any) => (
                                        <tr key={leave.userUID}>
                                            <td style={{ ...styles.tableHead, textAlign: "left", maxWidth: "50px" }}>{leave.userName}</td>
                                            {[...Array.from(Array(7).keys())].map((dayIndex) => {
                                                const currentDate = new Date(startDate);
                                                currentDate.setDate(currentDate.getDate() - currentDate.getDay() + dayIndex + 1);
                                                const formattedDate = currentDate.toISOString().split('T')[0];
                                                // Check if the current day is Saturday or Sunday
                                                if (currentDate.getDay() === 0 || currentDate.getDay() === 6) {
                                                    return (
                                                        <td key={dayIndex} style={{...styles.tableHead, display: screenWidth <= MOBILE_VIEW_WIDTH ? 'none' : 'table-cell',}}>
                                                            --
                                                        </td>
                                                    );
                                                }
                                                const leaveExist = leave.userLeaveData.some((leave: any) => {
                                                    const leaveStartDate = new Date(leave.startDate);
                                                    const leaveEndDate = new Date(leave.endDate);
                                                    return formattedDate >= leaveStartDate.toISOString().split('T')[0] && formattedDate <= leaveEndDate.toISOString().split('T')[0] && leave.status === "Approved";
                                                });
                                                return (
                                                    <td key={dayIndex} style={styles.tableHead}>
                                                        {leaveExist ? <img src={holidayIcon} alt="" width={25} /> : <img src={worker} alt="" width={25} />}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div style={styles.tableFooter}>
                            <button
                                style={styles.button}
                                onClick={onPrevWeek}
                            >
                                Previous Week
                            </button>
                            <button
                                style={styles.button}
                                onClick={onNextWeek}
                            >
                                Next Week
                            </button>
                        </div>
                        {
                            showLoader && <Loader />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

const styles = StyleSheetRW.create(() => ({
    mainContainer: { display: 'flex', flexDirection: 'row', height: "100%", fontFamily: "Outfit", },
    menuContainer: { width: '20%', backgroundColor: '#e8f0eb', padding: '20px' },
    contentContainer: { width: '80%', padding: '20px' },
    tableContainer: { width: "100%", marginTop: 20, marginBottom: 20 },
    tableHeader: { display: "flex", justifyContent: "space-between", marginBottom: 10 },
    tableWrapper: { overflow: "scroll", borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.2)' },
    tableRow: { backgroundColor: "#2F4858", color: "#FFFFFF" },
    tableHead: { padding: '15px', textAlign: 'center', borderBottom: '1px solid #2F4858', fontWeight: '300', maxWidth: 0 },
    tableFooter: { display: 'flex', justifyContent: 'space-between', marginTop: '20px' },
    heading: { fontWeight: 'bold', fontSize: 32, color: '#2F4858', marginTop: 20, width: "100%" },
    timerContainer: { width: '100%', backgroundColor: '#e8f0eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '8px', gap: '9px', paddingTop: "13px", paddingBottom: "13px" },
    timeText: { fontSize: 36, fontWeight: '500' },
    tableHeading: { fontSize: 20, fontWeight: 'bold', marginBottom: '10px' },
    tableStyle: { width: "100%", borderCollapse: "collapse", backgroundColor: '#FFFFFF66' },
    tableData1: { padding: '15px', borderLeft: '1px solid #2F485880' },
    button: { backgroundColor: '#2F4858', borderRadius: 100, width: "120px", height: "40px", outline: "none", border: "none", color: "#FFFFFF", cursor: "pointer", padding: 10 },
    input: { fontSize: 16, fontFamily: "Outfit", borderTopRightRadius: 10, height: 45, outline: "none", borderRadius: 10, paddingLeft: 15, marginTop: 5, borderStyle: "none", backgroundColor: "#0000000D", },
    holidaySummary: { backgroundColor: '#F2FBF2', padding: 20, borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.2)' },
    summaryItem: { display: 'flex', justifyContent: 'space-between', marginBottom: 10 },
    summaryLabel: { fontWeight: 'bold' },
    summaryValue: { color: '#2F4858' },
    holidayButton: { backgroundColor: '#2F4858', borderRadius: 100, width: "180px", height: "40px", outline: "none", border: "none", color: "#FFFFFF", cursor: "pointer", padding: 10, marginTop: 20 },
}))

export default TeamAvailability;